<script setup>
import { useLayout } from '@/layout/composables/layout';
import { ref, onBeforeMount, computed } from 'vue';
// import { loadLanguageAsync } from "laravel-vue-i18n";
// import { getActiveLanguage } from "laravel-vue-i18n";


const { layoutConfig } = useLayout();

const currentYear = ref(new Date());

// Start onBeforeMount Section
onBeforeMount(() => {
    
});
// End onBeforeMount Section


const logoUrl = computed(() => {
    return `layout/images/${layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.svg`;
});
</script>

<template>
    <div class="layout-footer rtl">
        <!-- <span class="font-medium ml-2">© {{ currentYear.getFullYear() }} <span style="color: #fb8500;"><span
                    style="color: #003049;">T</span>ou<span style="color: #003049;">t</span>a <span
                    style="color: #003049;">W</span>or<span style="color: #003049;">l</span>d</span></span> -->
        <!-- <img :src="logoUrl" alt="Logo" height="20" class="mr-2" /> -->
        <div class="container d-flex flex-wrap justify-content-center footer-container">
            <div class="contact-us d-flex flex-wrap">
                <a href="/privacy-policy" targer="_blank" class="text-white" :aria-label="`privacy policy`">{{
                    $t('privacy_policy') }}</a>
                <Divider layout="vertical" class="float-start" />
                <a href="/contact-us" targer="_blank" class="text-white" :aria-label="`contact us`">{{ $t('contact_us')
                    }}</a>
            </div>
            <div class="footer-socials d-flex flex-wrap">
                <a href="https://www.facebook.com/toutaworld" target="_blank" class="mt-a icon-link"
                    aria-label="Follow us on facebook">
                    <i class="bi bi-facebook"></i>
                </a>
                <a href="https://www.instagram.com/toutaworld7" target="_blank" class="icon-link mt-10"
                    aria-label="Follow us on instagram">
                    <i class="bi bi-instagram"></i>
                </a>
                <a href="https://www.tiktok.com/@toutaworld" target="_blank" class="icon-link mt-10"
                    aria-label="Follow us on tiktok">
                    <i class="bi bi-tiktok"></i>
                </a>
                <a href="https://www.youtube.com/@toutaworld7" target="_blank" class="icon-link mt-10"
                    aria-label="Follow us on youtube">
                    <i class="bi bi-youtube"></i>
                </a>
            </div>
            <div class="copy-right ltr">
                <span class="font-medium ml-2">© {{ currentYear.getFullYear() }}
                    <span>Touta World</span>
                </span>
            </div>
        </div>
    </div>
</template>
<style lang="css">
.layout-footer {
    background-color: #1e293b;
}

.layout-footer a,
.layout-footer span {
    color: #ffffff;
}

.layout-footer .footer-container>div {
    padding: 20px;
}

.layout-footer .footer-container .footer-socials .icon-link>i {
    font-size: 1.5rem;
    width: 3rem;
    height: 3rem;
    margin: 0 10px;
}

.layout-footer .footer-container .contact-us>a {
    padding: 20px 10px 10px;
}

.layout-footer .footer-container .copy-right {
    padding-top: 42px;
    vertical-align: middle;
}

.p-divider-vertical:before {
    top: 22% !important;
    height: 70% !important;
}
</style>
